import React from 'react';
import styled from 'styled-components';
import { Tooltip } from '~/components';
import QBO from './assets/qbo.svg?react';

const Wrapper = styled.span`
  display: inline-flex;
  align-items: center;
  width: 1rem;
  height: 1rem;
`;

const Icon = styled(QBO)`
  width: 1rem;
  height: 1rem;
`;

export default function QBOIndicator({ message, qboConnectionName, style }) {
  const defaultMessage = `This project is in ${qboConnectionName || 'QuickBooks'}.`;

  return (
    <Wrapper style={style}>
      <Tooltip message={message ?? defaultMessage} placement="right">
        <Icon />
      </Tooltip>
    </Wrapper>
  );
}
